// Single source of truth for the legal document version on the frontend.
//
// Bump LEGAL_VERSION (and the effective date) whenever the Terms of Service or
// Privacy Policy change materially. Signup sends this version to the API, which
// records what each user agreed to — so a future bump lets us detect who needs
// to re-consent. Keep this value in lockstep with back-end/lib/legal.js.
export const LEGAL_VERSION = '2026-11-01';

// Human-readable effective date shown at the top of the legal pages.
export const LEGAL_EFFECTIVE_DATE = 'November 1, 2026';

// Where legal/privacy questions should be directed.
export const LEGAL_CONTACT_EMAIL = 'privacy@thepinion.org';
